module.exports = __webpack_public_path__ + "static/together_event01_icon01-21ea81d7cf3a1926f4595cfa52efa6b1.png";